import { createSelector } from '@reduxjs/toolkit';

import type { ApiKeysState } from './types';

export interface ApiKeysStore {
  apiKeys: ApiKeysState;
}

export const selectIsOpenModal = (store: ApiKeysStore) => store.apiKeys.isOpenModal;

export const selectInitialValue = (store: ApiKeysStore) => store.apiKeys.modalInitialValue;

export const selectApiKeySubmitted = (store: ApiKeysStore) => store.apiKeys.reqApiKey === 'success';

export const selectApiKeySubmitting = (store: ApiKeysStore) =>
  store.apiKeys.reqApiKey === 'pending';

export const selectSelectedExchange = (store: ApiKeysStore) => store.apiKeys.selectedExchange;

export const selectTypeModal = (store: ApiKeysStore) => store.apiKeys.typeModal;

export const selectApiKeysError = (store: ApiKeysStore) => store.apiKeys.error;

/** The create/edit API key modal is open — in either mode. */
export const selectIsOpenNewApiKeyModal = createSelector(
  selectIsOpenModal,
  selectTypeModal,
  (isOpen, type) => isOpen && (type === 'new' || type === 'edit'),
);

export const selectIsOpenAddSubModal = createSelector(
  selectIsOpenModal,
  selectTypeModal,
  (isOpen, type) => isOpen && type === 'sub',
);
